export default __webpack_public_path__ + "static/media/Cost_Of_Vehicle.a6fa3c6f.svg";